import { withNamespaces } from "react-i18next";
import { Text, View } from "@react-pdf/renderer";
import styles from "../../Styles";

const ContactInformation = ({
  t,
  company,
}) => {
  const contactInformation = [
    {
      title: "Address",
      details: company?.establishmentAddress ?? "-",
    },
    {
      title: "Postcode / City",
      details:
        [
          company?.establishmentAddressPostCode,
          company?.establishmentAddressCity,
        ]
          .filter(Boolean)
          .join(" ") || "-",
    },
    {
      title: "Region / Country",
      details:
        [
          company?.establishmentAddressRegion,
          company?.establishmentAddressCountry,
        ]
          .filter(Boolean)
          .join(", ") || "-",
    },
    {
      title: "Phone Number",
      details:
        [
          company?.countryCallingCode ? `+${company.countryCallingCode}` : null,
          company?.phoneNumber,
        ]
          .filter(Boolean)
          .join(" ") || "-",
    },
    {
      title: "Deliverability",
      details:
        company?.establishmentDeliverabilityIndication === true
          ? "Established location is deliverable"
          : company?.establishmentDeliverabilityIndication === false
          ? "Established location is not deliverable"
          : "-",
    },
  ];

  const correspondenceAddress = [
    {
      title: "Address",
      details: company?.correspondenceAddress ?? "-",
    },
  ];

  return (
    <View style={styles.section} break>
      <Text style={styles.sectionSeparator}>
        {`${t("3.")} ${t("Contact Information")}`}
      </Text>

      {/* Table 1 */}
      <View style={styles.table} wrap={false}>
        {/* header row */}
        <View style={styles.tableRow} wrap={false} minPresenceAhead={24}>
          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Title")}
            </Text>
          </View>

          <View style={{ ...styles.tableColHeader, ...styles.borderRightNone }}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Details")}
            </Text>
          </View>
        </View>

        {/* body rows */}
        {contactInformation.map((d, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === contactInformation.length - 1 ? styles.tableLastRow : {}),
          };

          return (
            <View style={rowStyle} key={i} wrap={false}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t(d.title)}</Text>
              </View>

              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                <Text style={styles.tableCell}>{d.details ?? "-"}</Text>
              </View>
            </View>
          );
        })}
      </View>

      {/* Subsection title */}
      <Text style={styles.alphListItem}>
        {`3.2 ${t("Correspondence Address")}`}
      </Text>

      {/* Table 2 */}
      <View style={styles.table} wrap={false}>
        {/* header row */}
        <View style={styles.tableRow} wrap={false} minPresenceAhead={24}>
          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Title")}
            </Text>
          </View>

          <View style={{ ...styles.tableColHeader, ...styles.borderRightNone }}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Details")}
            </Text>
          </View>
        </View>

        {/* body rows */}
        {correspondenceAddress.map((d, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === correspondenceAddress.length - 1
              ? styles.tableLastRow
              : {}),
          };

          return (
            <View style={rowStyle} key={i} wrap={false}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t(d.title)}</Text>
              </View>

              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                <Text style={styles.tableCell}>{d.details ?? "-"}</Text>
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default withNamespaces()(ContactInformation);
